module.exports = __webpack_public_path__ + "static/media/favepay.22b00575.svg";